module.exports = __webpack_public_path__ + "img/s1-6.d502e679.png";